export default __webpack_public_path__ + "static/media/ProductPageImage07.d91368e5.jpg";